import React from 'react'

export const ResetButton = () => {
  return (
    <button className="button -fab resetApp" onClick={() => window.location.reload()}>
      <span className="material-icons">refresh</span>
    </button>
  )
}
